<template>
  <form action=""
    class="w-50 cardRegister container px-2 py-2 border border-secondary-subtle position-fixed top-50 start-50 translate-middle w-50 p-3">
    <button class="btn-close float-end me-2 mt-1" @click.prevent="close"></button>
    <h4 class="mt-3"><strong>Registrar variable general</strong></h4>
    <div class="row aling-items-center mt-3 mb-3">
      <div class="col-sm-5">
        <label for="pricename">Nombre de la variable:</label>
      </div>
      <div class="col-sm-5">
        <input type="text" v-model="variablename" class="form-control" id="variablename" />
      </div>
    </div>
    <div class="row aling-items-center mt-3 mb-1">
      <div class="col-sm-5">
        <label for="pricevalue">Valor: </label>
      </div>
      <div class="col-sm-5">
        <input type="number" v-model="variablevalue" class="form-control" id="variablevalue" step="1" min="0" />
      </div>
      <p class="mt-3"> <i>Recuerde que este valor debe estar expresado en porcentaje.</i></p>
    </div>
    <div>
      <button class="btn btn-danger mb-2" @click.prevent="registerVariable">
        Guardar variable
      </button>
    </div>
  </form>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      variablename: "",
      variablevalue: 0,
    };
  },
  methods: {
    async registerVariable() {
      if (
        this.variablename === "" ||
        this.variablevalue === 0
      ) {
        alert("Alguno de los campos está vácio, no se puede crear la variable.");
      } else {
        let formData = new FormData();
        formData.append("name", this.variablename);
        formData.append("value", this.variablevalue);
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/variable/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            alert("Variable: " + this.variablename + " creada con exito");
            this.cleanfields();
            this.$emit("hidePopUp", false)
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    cleanfields() {
      this.variablename = "";
      this.variablevalue = 0;
    },
    close() {
      this.$emit("hidePopUp", false)
    },
  },
};
</script>